export const formatTime = (date: any) => {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}
